import React, { useState, useEffect } from "react";
import { Layout, Button, Tooltip } from "antd";
import { NavLink } from "react-router-dom";
import {
  ContactsOutlined,
  FundViewOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { TEXT_CONSTANTS } from "../../../constants/Constants";

const { Sider } = Layout;

const LogBookSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); 
    };

    checkMobile(); 
    window.addEventListener("resize", checkMobile); 

    return () => {
      window.removeEventListener("resize", checkMobile); 
    };
  }, []);

  useEffect(() => {
    setCollapsed(!isMobile); 
  }, [isMobile]);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed); 
  };

  const NavItem = ({ to, icon, text }) => (
    <Tooltip title={collapsed ? text : ""} placement="right">
      <NavLink
        className={({ isActive }) =>
          `flex items-center px-3 py-2 rounded-md transition-colors ${
            isActive
              ? "bg-primary text-white"
              : "text-[#6B7280] hover:bg-gray-100"
          }`
        }
        to={to}
      >
        {icon}
        <span
          className={`ml-3 text-base font-medium transition-all duration-300 whitespace-nowrap ${
            collapsed ? "w-0 overflow-hidden" : "w-auto"
          }`}
        >
          {text}
        </span>
      </NavLink>
    </Tooltip>
  );

  const SidebarContent = (
    <div className="flex flex-col space-y-3 w-full px-2 mt-2">
      <NavItem
        to='/logbook/employee-process-management'
        icon={<ContactsOutlined  className="text-lg" />}
        text={TEXT_CONSTANTS.LOGBOOK_NEW_ENTRY}
      />
      <NavItem
        to='/logbook/view-entries'
        icon={<FundViewOutlined  className="text-lg" />}
        text={TEXT_CONSTANTS.LOGBOOK_VIEW_ENTRY}
      />
    </div>
  );

  return (
    !isMobile &&(
    <Sider
      className={`bg-white shadow-sm min-h-screen transition-all duration-300 relative`}
      width={180}
      collapsedWidth={60}
      collapsed={collapsed}
      theme="light"
    >
      <div className="flex justify-end px-2 py-2">
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={toggleCollapsed}
          className="z-11 mr-2"
        />
      </div>
      {SidebarContent}
    </Sider>
    )
  );
};

export default LogBookSidebar;
